<template>
  <div class="rpg-tooltip">
    <div
        ref="bubbleRef"
        class="rpg-tooltip__bubble"
        :class="bubbleClasses"
        :style="[bubbleStyle]"
    >
      <div class="rpg-tooltip__bubble-arrow"/>
      <div v-if="!hide"
           class="rpg-tooltip__bubble-content"
           :style="contentStyle"
      >
        <div
            ref="contentRef"
            style="display: inline-block"
        >
          <slot name="tooltip"/>
        </div>
      </div>
    </div>
    <slot/>
  </div>
</template>

<script>
import {computed, ref} from "vue";

export default {
  name: "Tooltip",
  props: {
    direction: {
      type: String,
      default: null,
    },
    requireHover: {
      type: Boolean,
      default: true
    },
    hide: {
      type: Boolean,
      default: false
    },
    adjustLeft: {
      type: Number,
      default: -25
    }
  },
  setup(props) {
    function getPosition(element) {
      var xPosition = 0;
      var yPosition = 0;

      while (element) {
        // only get the position of a element that is within the game borders
        if (element.className === "rpg-scrollbars") {
          break;
        }

        xPosition += (element.offsetLeft - element.scrollLeft + element.clientLeft);
        yPosition += (element.offsetTop - element.scrollTop + element.clientTop);
        element = element.offsetParent;
      }

      return {x: xPosition, y: yPosition};
    }

    const bubbleRef = ref(null);
    const contentRef = ref(null);
    const bubbleClasses = computed(() => {
      let forceDisplay = "rpg-tooltip";
      if (!props.requireHover) {
        forceDisplay += "-forceDisplay";
      }

      return ['rpg-tooltip__bubble', forceDisplay];

    });

    const bubbleStyle = computed(() => {
      if (contentRef.value !== null) {
        let screenWidth;

        screenWidth = 320;
        // fake a smaller screen so the tooltips don't try to be close to the border
        screenWidth = screenWidth * 0.5;

        let computedHeight = getComputedStyle(contentRef.value).height.replace("px", "");
        computedHeight = parseInt(computedHeight);
        let computedWidth = getComputedStyle(contentRef.value).width.replace("px", "");
        computedWidth = parseInt(computedWidth);

        let tooltip_position = getPosition(contentRef.value);
        let x = tooltip_position["x"];
        let y = tooltip_position["y"];

        let adjustedLeft = 0;
        if (x + computedWidth / 2 > screenWidth) {
          adjustedLeft = props.adjustLeft;
        }

        let adjustedTop = 0;
        if (y - computedHeight < 0) {
          adjustedTop = 50;
        }

        return {
          top: adjustedTop + 'px',
          left: adjustedLeft + 'px'
        };


      }
      return {};
    });


    function convertPXToVH(px) {
      return px * (100 / document.documentElement.clientHeight);
    }

    const contentStyle = computed(() => {
      if (contentRef.value !== null) {
        const computedWidth = getComputedStyle(contentRef.value).width.replace("px", "");

        let vw = convertPXToVH(computedWidth) + 1;

        return {width: (vw < 40 ? vw : 40) + "vh"};
      }
      return {};
    });

    return {
      bubbleClasses,
      contentRef,
      bubbleRef,
      contentStyle,
      bubbleStyle
    };
  }
};
</script>

<style scoped lang="scss">
.rpg-tooltip {
  position: relative;

  &__bubble {
    display: flex;
    transition: opacity .3s;
    opacity: 0;

    pointer-events: none;
    position: absolute;
    height: 100%;
    align-items: center;
    text-align: left;
    $background-color: #2f2f2f;
    z-index: 999;

    &-content {
      background-color: $background-color;
      color: white;
      padding: 7px;

      position: relative;
      width: 33vh;

      border: 2px solid #7a7a7a;
      border-radius: 10px;

      box-shadow: 6px 6px 5px black;
      z-index: 999;
    }

    &-arrow {
      width: 0;
      height: 0;
      position: absolute;
    }

    &--left &-arrow {
      border-top: 7px solid transparent;
      border-bottom: 7px solid transparent;
      border-left: 7px solid $background-color;
      right: 0;
    }

    &--right &-arrow {
      border-top: 7px solid transparent;
      border-bottom: 7px solid transparent;
      border-right: 7px solid $background-color;
      left: 0;
    }

    &--bottom &-arrow {
      border-right: 7px solid transparent;
      border-left: 7px solid transparent;
      border-bottom: 7px solid $background-color;
      top: 0;
    }

    &--top &-arrow {
      border-right: 7px solid transparent;
      border-left: 7px solid transparent;
      border-top: 7px solid $background-color;
      bottom: 0;
    }
  }

  &:hover &__bubble {
    opacity: 1;
  }


  &-forceDisplay {
    opacity: 1;
  }
}
</style>